export const strongTranslationsES = {
  "G11": {
    m: "Abraham",
    d: "El patriarca Abraham, padre de los creyentes.",
    u: "Usado 73 veces en el NT. Modelo de fe.",
    e: "Del hebreo אַבְרָהָם (Abraham) = padre de una multitud"
  },
  "G25": {
    m: "amar con amor divino e incondicional",
    d: "Amar con un amor desinteresado, sacrificial y divino. Es el amor de Dios por la humanidad y el amor que debemos tener unos por otros.",
    u: "Usado 143 veces en el NT. Describe el amor divino, perfecto e incondicional.",
    e: "De ἄγω (ago) = conducir, dirigir hacia el bien"
  },
  "G26": {
    m: "amor divino, caridad",
    d: "El amor perfecto de Dios; amor fraternal, afecto, buena voluntad, caridad. El amor que une a Dios y al hombre, y al hombre con su prójimo.",
    u: "Usado 116 veces en el NT. La palabra central del cristianismo para describir el amor divino.",
    e: "Derivado de ἀγαπάω (agapao)"
  },
  "G27": {
    m: "amado, querido",
    d: "Amado, querido; muy amado por Dios o por los hombres.",
    u: "Usado 61 veces en el NT. El Hijo amado de Dios.",
    e: "De ἀγαπάω (agapao) = amar"
  },
  "G32": {
    m: "ángel, mensajero",
    d: "Mensajero; ángel celestial al servicio de Dios.",
    u: "Usado 175 veces en el NT. Los ángeles de Dios.",
    e: "De ἀγγέλλω (aggello) = anunciar"
  },
  "G36": {
    m: "de baja cuna, innoble",
    d: "Sin nobleza, de baja extracción; despreciado.",
    u: "Usado 1 vez en el NT (1 Cor 1:28).",
    e: "De ἀ- (negativo) + γένος (genos) = nacimiento"
  },
  "G93": {
    m: "injusticia, iniquidad",
    d: "Violación del derecho, injusticia; maldad, iniquidad moral.",
    u: "Usado 25 veces en el NT. Contrario a δικαιοσύνη (justicia).",
    e: "De ἀ- (negativo) + δίκη (dike) = justicia"
  },
  "G154": {
    m: "pedir, orar, suplicar",
    d: "Pedir, orar por algo, suplicar, solicitar. Petición humilde y respetuosa.",
    u: "Usado 70 veces en el NT. Petición dirigida a Dios o a los hombres.",
    e: "De αἰτέω (aiteo) raíz primaria; pedir"
  },
  "G166": {
    m: "eterno, perpetuo",
    d: "Sin principio ni fin, que existe siempre; en el NT, a menudo ligado a la vida eterna en Dios.",
    u: "Usado 71 veces en el NT. Califica a menudo la vida eterna y el reino de Dios.",
    e: "De αἰών (aion) = edad, época, eternidad"
  },
  "G225": {
    m: "verdad, realidad",
    d: "Lo que es verdadero en las cosas concernientes a Dios y los deberes del hombre; la verdad divina revelada.",
    u: "Usado 109 veces en el NT. Concepto central de la enseñanza de Jesús.",
    e: "De ἀληθής (alethes) = verdadero, sincero"
  },
  "G281": {
    m: "amén, en verdad",
    d: "Fórmula de afirmación: que así sea, en verdad, ciertamente.",
    u: "Usado 129 veces en el NT. Jesús dice 'En verdad, en verdad'.",
    e: "Del hebreo אָמֵן (amen) = firme, fiel"
  },
  "G444": {
    m: "hombre, ser humano",
    d: "Ser humano, hombre o mujer; la humanidad en general.",
    u: "Usado 550 veces en el NT. El hombre creado a imagen de Dios.",
    e: "De ἀνήρ (aner) = hombre y ὤψ (ops) = rostro"
  },
  "G622": {
    m: "perder, destruir, perecer",
    d: "Destruir completamente; perder, perecer; ser arruinado.",
    u: "Usado 90 veces en el NT. Salvar lo que estaba perdido.",
    e: "De ἀπό (apo) = de + ὄλλυμι (ollumi) = destruir"
  },
  "G649": {
    m: "enviar, delegar",
    d: "Enviar con una misión; delegar como embajador.",
    u: "Usado 132 veces en el NT. El Padre envía al Hijo.",
    e: "De ἀπό (apo) = de + στέλλω (stello) = enviar"
  },
  "G721": {
    m: "cordero",
    d: "Pequeño cordero; designa a Jesucristo como el Cordero de Dios.",
    u: "Usado 30 veces en el NT, especialmente en el Apocalipsis.",
    e: "Diminutivo de ἀρήν (aren) = cordero"
  },
  "G730": {
    m: "varón, masculino",
    d: "De sexo masculino, varón.",
    u: "Usado 9 veces en el NT. Dios creó al hombre varón y hembra.",
    e: "Raíz primaria"
  },
  "G740": {
    m: "pan",
    d: "Pan, alimento; el pan de vida = Cristo.",
    u: "Usado 97 veces en el NT. Jesús el pan de vida.",
    e: "De ἄρω (aro) = levantar, alzar"
  },
  "G746": {
    m: "principio, comienzo",
    d: "El principio, el origen, el primer principio. En Juan 1:1-2, designa el principio eterno donde ya existía la Palabra (Logos).",
    u: "Usado 55 veces en el NT. Palabra clave de Juan 1:1 'En el principio era la Palabra'.",
    e: "Palabra primaria; principio, origen primero"
  },
  "G772": {
    m: "débil, enfermo",
    d: "Sin fuerza, débil; enfermo, enfermizo; espiritualmente débil.",
    u: "Usado 25 veces en el NT. Dios escoge a los débiles del mundo.",
    e: "De ἀ- (negativo) + σθένος (sthenos) = fuerza"
  },
  "G907": {
    m: "bautizar, sumergir",
    d: "Sumergir en agua; bautizar para purificar o iniciar.",
    u: "Usado 77 veces en el NT. El bautismo cristiano.",
    e: "De βάπτω (bapto) = sumergir, inmersionar"
  },
  "G1080": {
    m: "engendrar, hacer nacer",
    d: "Engendrar, dar a luz; nacer de nuevo espiritualmente.",
    u: "Usado 97 veces en el NT. Nacer de Dios, nacer de nuevo.",
    e: "Raíz primaria"
  },
  "G1096": {
    m: "llegar a ser, suceder, hacerse",
    d: "Llegar a ser, venir a la existencia, suceder, tener lugar, producirse.",
    u: "Usado 678 veces en el NT. 'Todas las cosas fueron hechas por ella' (Juan 1:3).",
    e: "De la raíz γίνομαι (ginomai) = llegar a ser"
  },
  "G1097": {
    m: "conocer, saber, comprender",
    d: "Conocer por experiencia personal; comprender, percibir, ser consciente de.",
    u: "Usado 222 veces en el NT. Conocimiento experiencial, no solo intelectual.",
    e: "Raíz indoeuropea *gen- = engendrar, conocer"
  },
  "G1100": {
    m: "lengua, idioma",
    d: "Órgano del habla; idioma, dialecto; don de lenguas.",
    u: "Usado 50 veces en el NT. El don de lenguas.",
    e: "Raíz primaria"
  },
  "G1166": {
    m: "mostrar, demostrar",
    d: "Exponer a los ojos, mostrar; probar, demostrar.",
    u: "Usado 33 veces en el NT. Dios muestra su gloria.",
    e: "Raíz primaria"
  },
  "G1208": {
    m: "segundo",
    d: "El segundo en una serie o un orden.",
    u: "Usado 44 veces en el NT. El segundo mandamiento.",
    e: "De δύο (duo) = dos"
  },
  "G1271": {
    m: "inteligencia, pensamiento",
    d: "La facultad de pensar, de entender, de comprender; la mente, la comprensión.",
    u: "Usado 12 veces en el NT. La mente renovada por Cristo.",
    e: "De διά (dia) = a través + νοῦς (nous) = mente"
  },
  "G1320": {
    m: "maestro, doctor",
    d: "Maestro, instructor; uno que enseña las verdades religiosas.",
    u: "Usado 59 veces en el NT. 'Rabí, sabemos que eres un maestro venido de Dios' (Juan 3:2).",
    e: "De διδάσκω (didasko) = enseñar"
  },
  "G1325": {
    m: "dar, conceder",
    d: "Dar algo a alguien; conceder, permitir; entregar.",
    u: "Usado 415 veces en el NT. Dios da generosamente.",
    e: "Raíz primaria"
  },
  "G1372": {
    m: "tener sed, desear ardientemente",
    d: "Sufrir de sed; desear ardientemente, aspirar a.",
    u: "Usado 16 veces en el NT. Sed espiritual de Dios.",
    e: "De δίψα (dipsa) = sed"
  },
  "G1401": {
    m: "esclavo, siervo",
    d: "Esclavo, siervo; siervo voluntario de Dios.",
    u: "Usado 124 veces en el NT. Siervos de Cristo.",
    e: "De δέω (deo) = atar"
  },
  "G1411": {
    m: "poder, fuerza, milagro",
    d: "Fuerza, poder, capacidad; acto de poder, milagro.",
    u: "Usado 120 veces en el NT. El poder de Dios, del Espíritu Santo.",
    e: "De δύναμαι (dunamai) = ser capaz"
  },
  "G1417": {
    m: "dos",
    d: "El número dos; un par.",
    u: "Usado 135 veces en el NT. Dos o tres testigos.",
    e: "Raíz primaria"
  },
  "G1473": {
    m: "yo, mí",
    d: "Pronombre personal de la primera persona del singular.",
    u: "Usado 2567 veces en el NT. Muy frecuente.",
    e: "Pronombre primario"
  },
  "G1484": {
    m: "nación, pueblo, gentiles",
    d: "Pueblo, nación; las naciones gentiles (no judíos).",
    u: "Usado 162 veces en el NT. El evangelio para todas las naciones.",
    e: "Raíz primaria"
  },
  "G1492": {
    m: "saber, ver, conocer",
    d: "Saber por percepción, ver, comprender, conocer. Conocimiento adquirido por la experiencia o la revelación.",
    u: "Usado 666 veces en el NT. Verbo fundamental del conocimiento en el Evangelio de Juan.",
    e: "Forma perfecta de εἴδω (eido); ver, saber"
  },
  "G1510": {
    m: "ser, existir",
    d: "Verbo ser en todos sus sentidos; existir, permanecer, tener lugar.",
    u: "El verbo más usado en el NT (2460+ veces).",
    e: "Raíz primaria"
  },
  "G1515": {
    m: "paz",
    d: "Estado de tranquilidad; paz con Dios; armonía entre las personas.",
    u: "Usado 92 veces en el NT. La paz de Cristo.",
    e: "De εἴρω (eiro) = unir, atar"
  },
  "G1520": {
    m: "uno, único",
    d: "Uno solo; único, solamente; cierto.",
    u: "Usado 344 veces en el NT. La unidad de Dios, la iglesia unida.",
    e: "Raíz primaria"
  },
  "G1586": {
    m: "elegir, escoger",
    d: "Elegir para sí, seleccionar; elegir por gracia divina.",
    u: "Usado 21 veces en el NT. Dios elige a sus hijos.",
    e: "De ἐκ (ek) = fuera de + λέγω (lego) = escoger"
  },
  "G1658": {
    m: "libre, liberado",
    d: "Libre, no esclavo; liberado de la esclavitud del pecado.",
    u: "Usado 23 veces en el NT. Liberados en Cristo.",
    e: "Probablemente de ἔρχομαι (erchomai) = venir"
  },
  "G1672": {
    m: "griego, gentil",
    d: "Un griego de nacimiento o de lengua; un no judío.",
    u: "Usado 25 veces en el NT. Ni judío ni griego en Cristo.",
    e: "De Ἑλλάς (Hellas) = Grecia"
  },
  "G1680": {
    m: "esperanza, expectativa confiada",
    d: "Expectativa de cosas buenas, esperanza fundada en Dios; confianza en el futuro basada en las promesas divinas.",
    u: "Usado 54 veces en el NT. Una de las tres virtudes teologales con la fe y el amor.",
    e: "De ἔλπω (elpo) = esperar, tener esperanza"
  },
  "G1743": {
    m: "fortalecer, hacer fuerte",
    d: "Hacer fuerte, fortalecer; dar poder.",
    u: "Usado 8 veces en el NT. Dios fortalece a los creyentes.",
    e: "De ἐν (en) = en + δυναμόω (dynamoo) = hacer poderoso"
  },
  "G1746": {
    m: "revestir, vestirse",
    d: "Ponerse una vestidura; revestirse de una cualidad o de un poder.",
    u: "Usado 27 veces en el NT. Revestirse de Cristo, revestirse de la armadura de Dios.",
    e: "De ἐν (en) = en + δύω (duo) = entrar, revestir"
  },
  "G1785": {
    m: "mandamiento, orden",
    d: "Una orden, mandamiento, precepto; especialmente un mandamiento divino.",
    u: "Usado 67 veces en el NT. Los mandamientos de Dios y de Cristo.",
    e: "De ἐντέλλομαι (entellomai) = mandar"
  },
  "G1848": {
    m: "despreciar, tratar con desprecio",
    d: "Considerar como nada, despreciar; tratar con desdén.",
    u: "Usado 11 veces en el NT. El mundo desprecia lo que Dios elige.",
    e: "De ἐξ (ex) = fuera de + οὐθείς (outheis) = nadie"
  },
  "G2041": {
    m: "obra, trabajo, acto",
    d: "Trabajo, labor; acción, acto; obra realizada.",
    u: "Usado 169 veces en el NT. Las obras de Dios, las buenas obras.",
    e: "De ἔργω (ergo) = trabajar"
  },
  "G2048": {
    m: "desierto, solitario",
    d: "Lugar desierto, wilderness; solitario, despoblado.",
    u: "Usado 48 veces en el NT. Los 40 días de Jesús en el desierto.",
    e: "De ἔρημος (eremos) = abandonado"
  },
  "G2065": {
    m: "preguntar, interrogar, solicitar",
    d: "Preguntar, interrogar, pedir información. Encuesta o investigación.",
    u: "Usado 63 veces en el NT. Preguntar para obtener respuestas.",
    e: "Raíz incierta; preguntar, interrogar"
  },
  "G2189": {
    m: "enemistad, hostilidad",
    d: "Odio, hostilidad, enemistad.",
    u: "Usado 6 veces en el NT. La enemistad con Dios abolida.",
    e: "De ἐχθρός (echthros) = enemigo"
  },
  "G2205": {
    m: "celo, celos, envidia",
    d: "Ardor apasionado; puede ser positivo (celo por Dios) o negativo (celos, envidia).",
    u: "Usado 16 veces en el NT. Puede ser virtuoso o vicioso según el contexto.",
    e: "De ζέω (zeo) = hervir, ser ferviente"
  },
  "G2222": {
    m: "vida",
    d: "Vida física o espiritual; la vida eterna en Dios.",
    u: "Usado 135 veces en el NT. Jesús es la vida.",
    e: "De ζάω (zao) = vivir"
  },
  "G2258": {
    m: "era, él era",
    d: "Era, él era, ella era. Forma de imperfecto del verbo ser (εἰμί). Expresa un estado o una existencia en el pasado.",
    u: "Usado 267 veces en el NT. Crucial en Juan 1:1 'En el principio era la Palabra'.",
    e: "Imperfecto de εἰμί (eimi) = ser; era"
  },
  "G2296": {
    m: "asombrarse, maravillarse, admirar",
    d: "Asombrarse, maravillarse, sorprenderse, admirar. Reacción de asombro ante algo extraordinario.",
    u: "Usado 43 veces en el NT. Reacción frecuente a los milagros y enseñanzas de Jesús.",
    e: "De θαῦμα (thauma) = maravilla; maravillarse"
  },
  "G2316": {
    m: "Dios, divinidad",
    d: "La Divinidad suprema - especialmente (con el artículo) el Dios único y verdadero. En la Escritura, revela al Dios único que se manifiesta como Padre, Hijo y Espíritu Santo, sin división de la esencia divina.",
    u: "Usado 1343 veces en el NT según las fuentes bíblicas. Palabra central que designa al único Dios verdadero y Sus obras.",
    e: "De afinidad incierta según Strong. Designa una divinidad, particularmente la Divinidad suprema. Uso bíblico: revela al Dios viviente que actúa en la historia de la salvación."
  },
  "G2338": {
    m: "hembra, femenino",
    d: "De sexo femenino, hembra.",
    u: "Usado 5 veces en el NT. Hombre y mujer iguales en Cristo.",
    e: "De θηλάζω (thelazo) = amamantar"
  },
  "G2362": {
    m: "trono",
    d: "Asiento real, trono; poder y autoridad real.",
    u: "Usado 62 veces en el NT. El trono de Dios y del Cordero.",
    e: "Raíz primaria"
  },
  "G2381": {
    m: "Tomás",
    d: "Tomás, nombre propio. Uno de los doce apóstoles, llamado también Dídimo (gemelo). Conocido por su petición de pruebas de la resurrección.",
    u: "Usado 11 veces en el NT. El apóstol que dudó y luego creyó.",
    e: "Del arameo תְּאוֹמָא (teoma) = gemelo"
  },
  "G2398": {
    m: "propio, particular, personal",
    d: "Propio, particular, personal, privado. Lo que pertenece en propiedad a alguien, distinto de los demás.",
    u: "Usado 114 veces en el NT. Concepto de pertenencia personal y de distinción.",
    e: "De raíz incierta; propio, particular"
  },
  "G2424": {
    m: "Jesús",
    d: "Jesús de Nazaret, el Mesías, el Salvador.",
    u: "Usado 917 veces en el NT. El nombre sobre todo nombre.",
    e: "Del hebreo יְהוֹשֻׁעַ (Yehoshua) = YHWH salva"
  },
  "G2453": {
    m: "judío, judeo",
    d: "Perteneciente a la raza judía; habitante de Judea.",
    u: "Usado 195 veces en el NT. Los judíos, pueblo elegido de Dios.",
    e: "De Ἰούδας (Ioudas) = Judá"
  },
  "G2491": {
    m: "Juan",
    d: "Juan, nombre propio. Juan el Bautista el precursor, Juan el apóstol amado, autor del Evangelio y de las epístolas.",
    u: "Usado 135 veces en el NT. Nombre de dos grandes figuras del NT.",
    e: "Del hebreo יוֹחָנָן (Yochanan) = YHWH hace gracia"
  },
  "G2531": {
    m: "como, según que",
    d: "Como, de la misma manera que; según que, en la medida en que.",
    u: "Usado 182 veces en el NT. Conjunción comparativa.",
    e: "De κατά (kata) = según + ὡς (hos) = como"
  },
  "G2537": {
    m: "nuevo, reciente",
    d: "Nuevo en el tiempo o la cualidad; fresco, reciente, no usado.",
    u: "Usado 42 veces en el NT. Nueva creación, nuevo mandamiento.",
    e: "Raíz incierta"
  },
  "G2570": {
    m: "bueno, hermoso",
    d: "Bueno en su naturaleza, hermoso; honorable, excelente, virtuoso.",
    u: "Usado 100 veces en el NT. El buen pastor, las buenas obras.",
    e: "Raíz primaria"
  },
  "G2588": {
    m: "corazón",
    d: "El corazón físico; el centro de la vida interior, el alma, el espíritu; los pensamientos y los sentimientos.",
    u: "Usado 156 veces en el NT. Sede de la vida espiritual.",
    e: "Raíz primaria"
  },
  "G2596": {
    m: "según, contra, a través",
    d: "Preposición con varios sentidos: según, conforme a; contra; a través.",
    u: "Usado más de 470 veces en el NT. Preposición muy frecuente.",
    e: "Preposición primaria"
  },
  "G2617": {
    m: "avergonzar, deshonrar",
    d: "Avergonzar, deshonrar; confundir, humillar.",
    u: "Usado 13 veces en el NT. Dios confunde a los sabios del mundo.",
    e: "De κατά (kata) = contra + αἰσχύνω (aischuno) = tener vergüenza"
  },
  "G2744": {
    m: "gloriarse, jactarse",
    d: "Gloriarse, jactarse; encontrar su orgullo en algo.",
    u: "Usado 37 veces en el NT. Gloriarse en el Señor.",
    e: "De καῦχος (kauchos) = jactancia"
  },
  "G2889": {
    m: "mundo, universo, humanidad",
    d: "El orden del mundo, el universo; la humanidad caída; el sistema opuesto a Dios.",
    u: "Usado 186 veces en el NT. Puede designar la creación o el sistema pecador.",
    e: "De κοσμέω (kosmeo) = adornar, arreglar"
  },
  "G2919": {
    m: "juzgar, decidir",
    d: "Juzgar, pronunciar un juicio; decidir, determinar.",
    u: "Usado 114 veces en el NT. Dios juzga al mundo.",
    e: "Raíz primaria"
  },
  "G2920": {
    m: "juicio, justicia, condenación",
    d: "Juicio, justicia, condenación, decisión judicial. El juicio de Dios, justo y perfecto.",
    u: "Usado 47 veces en el NT. Concepto central de la justicia divina.",
    e: "De κρίνω (krino) = juzgar, decidir"
  },
  "G2962": {
    m: "Señor, Maestro, propietario",
    d: "Señor, Maestro; título de respeto y de autoridad divina; Jesús como Señor.",
    u: "Usado 748 veces en el NT. 'Tomás le dijo: Señor, no sabemos adónde vas' (Juan 14:5).",
    e: "De κύριος (kurios) = tener autoridad"
  },
  "G2992": {
    m: "pueblo",
    d: "Un pueblo, una nación; especialmente el pueblo de Dios (Israel o la Iglesia).",
    u: "Usado 142 veces en el NT. El pueblo elegido de Dios.",
    e: "Raíz primaria"
  },
  "G3022": {
    m: "blanco, brillante",
    d: "Blanco, resplandeciente; símbolo de pureza y de victoria.",
    u: "Usado 25 veces en el NT. Las vestiduras blancas de los redimidos.",
    e: "De λευκός (leukos) = blanco, luminoso"
  },
  "G3056": {
    m: "palabra, verbo, razón",
    d: "Palabra pronunciada; razón, inteligencia; el Logos = Cristo.",
    u: "Usado 330 veces en el NT. El Logos encarnado.",
    e: "De λέγω (lego) = decir"
  },
  "G3101": {
    m: "discípulo, alumno",
    d: "Un aprendiz, estudiante, discípulo; seguidor de Jesús.",
    u: "Usado 261 veces en el NT. Designa a los seguidores de Cristo.",
    e: "De μανθάνω (manthano) = aprender"
  },
  "G3141": {
    m: "testimonio, atestación",
    d: "Testimonio, atestación, prueba. Testimonio dado a la verdad, particularmente a Cristo.",
    u: "Usado 37 veces en el NT. Tema mayor del Evangelio de Juan.",
    e: "De μάρτυς (martus) = testigo"
  },
  "G3173": {
    m: "grande, importante",
    d: "Grande en tamaño, en cantidad o en importancia; poderoso, maravilloso.",
    u: "Usado 243 veces en el NT. La grandeza de Dios.",
    e: "Raíz primaria"
  },
  "G3320": {
    m: "muro de separación",
    d: "Muro medianero, tabique de separación.",
    u: "Usado 1 vez en el NT (Ef 2:14). El muro entre judíos y gentiles.",
    e: "De μέσος (mesos) = medio + τοῖχος (toichos) = muro"
  },
  "G3439": {
    m: "único, unigénito",
    d: "Único en su género, único engendrado; hijo único.",
    u: "Usado 9 veces en el NT. El Hijo unigénito de Dios.",
    e: "De μόνος (monos) = solo + γίνομαι (ginomai) = llegar a ser"
  },
  "G3474": {
    m: "locura, insensatez",
    d: "Locura, absurdo; lo que carece de sabiduría.",
    u: "Usado 5 veces en el NT. La sabiduría de Dios parece locura al mundo.",
    e: "De μωρός (moros) = loco, insensato"
  },
  "G3475": {
    m: "Moisés",
    d: "Moisés, el legislador de Israel.",
    u: "Usado 80 veces en el NT. La ley de Moisés.",
    e: "Del hebreo מֹשֶׁה (Mosheh) = sacado (de las aguas)"
  },
  "G3530": {
    m: "Nicodemo",
    d: "Nicodemo, nombre propio. Fariseo y dirigente judío que vino a ver a Jesús de noche. Nombre griego que significa 'victoria del pueblo'.",
    u: "Usado 5 veces en el NT. Personaje importante en el Evangelio de Juan.",
    e: "Del griego νίκη (nikē) = victoria y δῆμος (dēmos) = pueblo"
  },
  "G3551": {
    m: "ley, Torá",
    d: "Ley, Torá, regla, principio. La ley de Moisés, la ley divina, los mandamientos de Dios.",
    u: "Usado 194 veces en el NT. Concepto central de la revelación divina.",
    e: "De νέμω (nemo) = distribuir, dar; ley dada"
  },
  "G3571": {
    m: "noche",
    d: "Noche, período de oscuridad entre la puesta y la salida del sol. A menudo metafórico para la ignorancia espiritual.",
    u: "Usado 61 veces en el NT. Contrastada con la luz en la simbología juanina.",
    e: "Nombre femenino primario; noche"
  },
  "G3598": {
    m: "camino, vía",
    d: "Ruta, camino; manera de vivir, conducta; la vía de la salvación.",
    u: "Usado 101 veces en el NT. Jesús es el camino.",
    e: "Raíz primaria"
  },
  "G3609": {
    m: "doméstico, de la casa",
    d: "Perteneciente a la casa, miembro de la familia; sirviente doméstico.",
    u: "Usado 3 veces en el NT. Describe a los miembros de la familia de Dios.",
    e: "De οἶκος (oikos) = casa"
  },
  "G3664": {
    m: "semejante, parecido",
    d: "Semejante, de la misma naturaleza o carácter; equivalente.",
    u: "Usado 45 veces en el NT. El segundo mandamiento semejante al primero.",
    e: "De ὁμός (homos) = mismo"
  },
  "G3686": {
    m: "nombre",
    d: "Nombre, título; reputación; autoridad, poder.",
    u: "Usado 228 veces en el NT. El nombre de Jesús.",
    e: "Raíz primaria"
  },
  "G3708": {
    m: "ver, mirar",
    d: "Ver con los ojos; percibir, comprender; aparecer.",
    u: "Usado 454 veces en el NT. Ver a Cristo, ver al Padre.",
    e: "Raíz primaria"
  },
  "G3735": {
    m: "montaña, colina",
    d: "Montaña, monte; colina elevada.",
    u: "Usado 63 veces en el NT. La montaña de la transfiguración.",
    e: "Probablemente de ὁράω (horao) = ver"
  },
  "G3756": {
    m: "no, no... ",
    d: "Negación absoluta, no, no.",
    u: "Usado más de 1600 veces en el NT. Partícula de negación muy frecuente.",
    e: "Partícula primaria de negación"
  },
  "G3762": {
    m: "nadie, nada, ninguno",
    d: "Nadie, nada, ninguno, nulo. Negación absoluta de la existencia o de la cantidad.",
    u: "Usado 234 veces en el NT. Negación fuerte muy común.",
    e: "De οὐδέ (oude) y εἷς (heis); ni siquiera uno"
  },
  "G3778": {
    m: "este, esta, esto",
    d: "Pronombre demostrativo: este, esta, esto. Designa algo cercano o previamente mencionado.",
    u: "Usado 1388 veces en el NT. Pronombre demostrativo más frecuente.",
    e: "Pronombre demostrativo primario"
  },
  "G3789": {
    m: "serpiente",
    d: "Serpiente, reptil; la serpiente antigua (Satanás).",
    u: "Usado 14 veces en el NT. La serpiente de bronce en el desierto.",
    e: "Raíz primaria"
  },
  "G3793": {
    m: "multitud, muchedumbre",
    d: "Multitud de gente, muchedumbre; la masa popular.",
    u: "Usado 175 veces en el NT. Las multitudes que seguían a Jesús.",
    e: "De ὄχος (ochos) = vehículo (que transporta)"
  },
  "G3880": {
    m: "recibir, tomar, aceptar",
    d: "Recibir, tomar, aceptar, asir. Recibir algo que es ofrecido o dado.",
    u: "Usado 59 veces en el NT. Concepto central de la aceptación del Evangelio.",
    e: "De παρά (para) = junto a y λαμβάνω (lambanō) = tomar"
  },
  "G3956": {
    m: "todo, cada",
    d: "Todo, cada, todos; el conjunto, la totalidad.",
    u: "Usado 1244 veces en el NT. Entre las palabras más frecuentes.",
    e: "Raíz primaria"
  },
  "G3962": {
    m: "padre",
    d: "Un padre natural o espiritual; antepasado; Dios el Padre.",
    u: "Usado 413 veces en el NT. A menudo para designar a Dios.",
    e: "Raíz primaria emparentada con el latín 'pater'"
  },
  "G4100": {
    m: "creer, tener fe",
    d: "Tener fe en, creer; confiar en, apoyarse en.",
    u: "Usado 241 veces en el NT. Creer en Jesús para ser salvado.",
    e: "De πίστις (pistis) = fe"
  },
  "G4102": {
    m: "fe, confianza, fidelidad",
    d: "Convicción de la verdad de cualquier cosa, creencia; en el NT de una convicción concerniente a la relación del hombre con Dios y las cosas divinas.",
    u: "Usado 244 veces en el NT. Concepto central de la fe cristiana.",
    e: "De πείθω (peitho) = persuadir, convencer"
  },
  "G4138": {
    m: "plenitud, abundancia, lo que llena",
    d: "Plenitud, abundancia, lo que llena completamente. La totalidad, la completud divina.",
    u: "Usado 17 veces en el NT. Concepto teológico de la plenitud divina en Cristo.",
    e: "De πλήρης (plērēs) = lleno; plenitud"
  },
  "G4139": {
    m: "prójimo, vecino",
    d: "El que está cerca, el vecino; el prójimo en general.",
    u: "Usado 17 veces en el NT. 'Amar a tu prójimo como a ti mismo'.",
    e: "Adverbio convertido en nombre, de πλησίος (plesios) = cerca"
  },
  "G4151": {
    m: "espíritu, aliento, viento",
    d: "El aliento de vida, el principio vital; el alma racional; el Espíritu Santo.",
    u: "Usado 385 veces en el NT. Designa al Espíritu Santo, el espíritu humano o espíritus.",
    e: "De πνέω (pneo) = soplar, respirar"
  },
  "G4160": {
    m: "hacer, realizar, actuar",
    d: "Hacer, realizar, producir, actuar, crear. Verbo de acción general que cubre todo tipo de actividad.",
    u: "Usado 568 veces en el NT. Verbo de acción fundamental, a menudo en las obras de Dios.",
    e: "Verbo primario; hacer, realizar"
  },
  "G4166": {
    m: "pastor",
    d: "El que guarda las ovejas; guardián espiritual, pastor de iglesia.",
    u: "Usado 18 veces en el NT. Jesús el buen pastor.",
    e: "De ποίμνη (poimne) = rebaño"
  },
  "G4183": {
    m: "mucho, numeroso, grande",
    d: "Mucho, numeroso, grande en cantidad o en número. Multitud, gran cantidad.",
    u: "Usado 416 veces en el NT. Adjetivo cuantitativo muy frecuente.",
    e: "Raíz incierta; mucho, numeroso"
  },
  "G4198": {
    m: "ir, andar, viajar",
    d: "Ir, andar, viajar, desplazarse. Movimiento de un lugar a otro, a menudo con un propósito.",
    u: "Usado 154 veces en el NT. Verbo de movimiento fundamental en los relatos evangélicos.",
    e: "Verbo primario; ir, andar"
  },
  "G4238": {
    m: "hacer, practicar, realizar",
    d: "Hacer, practicar, realizar, actuar. Realizar acciones, a menudo con la idea de repetición o de hábito.",
    u: "Usado 39 veces en el NT. A menudo ligado a la práctica del bien o del mal.",
    e: "Forma reforzada de πράω (praō); hacer, practicar"
  },
  "G4263": {
    m: "oveja",
    d: "Oveja o cordero; metafóricamente, los discípulos de Cristo.",
    u: "Usado 39 veces en el NT. Los creyentes como ovejas del pastor.",
    e: "Probablemente relacionado con προβαίνω (probaino) = avanzar"
  },
  "G4413": {
    m: "primero, principal",
    d: "Primero en el tiempo, el lugar, el orden o la importancia.",
    u: "Usado 155 veces en el NT. El primer mandamiento, el primer lugar.",
    e: "Superlativo de πρό (pro) = antes"
  },
  "G4561": {
    m: "carne, cuerpo",
    d: "Carne, carne animal; el cuerpo humano; la naturaleza humana caída.",
    u: "Usado 147 veces en el NT. Contraste entre carne y espíritu.",
    e: "Raíz primaria"
  },
  "G4592": {
    m: "señal, milagro, prodigio",
    d: "Señal, milagro, prodigio; manifestación sobrenatural que revela el poder divino.",
    u: "Usado 77 veces en el NT. 'porque nadie puede hacer estos milagros que tú haces' (Juan 3:2).",
    e: "De σημεῖον (semeion) = marca, señal"
  },
  "G4648": {
    m: "mirar atentamente, apuntar",
    d: "Fijar los ojos en, considerar atentamente; tener en vista, apuntar a un objetivo.",
    u: "Usado 6 veces en el NT. Llamado a fijar los ojos en Cristo.",
    e: "Relacionado con σκοπός (skopos) = blanco, objetivo"
  },
  "G4680": {
    m: "sabio, erudito",
    d: "Sabio, inteligente, hábil; formado, instruido.",
    u: "Usado 22 veces en el NT. La verdadera sabiduría viene de Dios.",
    e: "Raíz primaria"
  },
  "G4982": {
    m: "salvar, librar",
    d: "Salvar de peligro o destrucción; librar del pecado.",
    u: "Usado 106 veces en el NT. Jesús salva a los pecadores.",
    e: "De σῶς (sos) = sano y salvo"
  },
  "G5040": {
    m: "niño pequeño",
    d: "Niño pequeño, niño de corta edad; término afectuoso para discípulo.",
    u: "Usado 8 veces en el NT. Juan llama a sus lectores 'hijitos'.",
    e: "Diminutivo de τέκνον (teknon) = hijo"
  },
  "G5087": {
    m: "poner, colocar, establecer",
    d: "Poner, colocar; establecer, nombrar; depositar, poner.",
    u: "Usado 100 veces en el NT. Poner su vida por las ovejas.",
    e: "Raíz primaria"
  },
  "G5109": {
    m: "muro",
    d: "Muro de separación, pared.",
    u: "Usado 1 vez en el NT (Hechos 23:3).",
    e: "Raíz primaria"
  },
  "G5207": {
    m: "hijo",
    d: "Descendiente varón; discípulo; miembro de un grupo. El Hijo de Dios = Jesucristo.",
    u: "Usado 377 veces en el NT. A menudo para designar a Jesús como Hijo de Dios.",
    e: "Origen incierto, quizás relacionado con ὕω (huo) = hacer llover, engendrar"
  },
  "G5281": {
    m: "paciencia, resistencia, perseverancia",
    d: "Cualidad del que no sucumbe a las circunstancias o a las presiones; resistencia paciente, constancia.",
    u: "Usado 32 veces en el NT. Virtud cristiana esencial.",
    e: "De ὑπό (hupo) = bajo y μένω (meno) = permanecer"
  },
  "G5312": {
    m: "elevar, exaltar",
    d: "Levantar en alto, elevar; exaltar, honrar.",
    u: "Usado 20 veces en el NT. El Hijo del Hombre elevado.",
    e: "De ὕψος (hupsos) = altura"
  },
  "G5376": {
    m: "Felipe",
    d: "Felipe, nombre propio. Uno de los doce apóstoles. Nombre griego que significa 'amigo de los caballos'.",
    u: "Usado 36 veces en el NT. Nombre del apóstol y del diácono.",
    e: "Del griego φίλος (philos) = amigo y ἵππος (hippos) = caballo"
  },
  "G5432": {
    m: "guardar, proteger",
    d: "Guardar por una guardia militar; proteger, preservar.",
    u: "Usado 4 veces en el NT. La paz de Dios guarda nuestros corazones.",
    e: "De φρουρός (phrouros) = guardia, centinela"
  },
  "G5443": {
    m: "tribu, pueblo",
    d: "Tribu, clan; un pueblo descendiente de un antepasado común.",
    u: "Usado 31 veces en el NT. Las doce tribus de Israel.",
    e: "De φύω (phuo) = producir, hacer crecer"
  },
  "G5457": {
    m: "luz",
    d: "Luz física o espiritual; la verdad divina revelada.",
    u: "Usado 73 veces en el NT. Jesús luz del mundo.",
    e: "De φάω (phao) = brillar"
  },
  "G5463": {
    m: "regocijarse, estar alegre",
    d: "Regocijarse, estar feliz; saludo 'regocíjate' o 'salud'.",
    u: "Usado 74 veces en el NT. Mandato frecuente de regocijarse en Cristo.",
    e: "Emparentado con χάρις (charis) = gracia"
  },
  "G5495": {
    m: "mano",
    d: "La mano; poder, autoridad; acción, obra.",
    u: "Usado 177 veces en el NT. La mano de Dios, las manos de Jesús.",
    e: "Raíz primaria"
  },
  "G5544": {
    m: "bondad, benevolencia",
    d: "Bondad en acción, benevolencia práctica; cualidad del que es útil, provechoso a los demás.",
    u: "Usado 10 veces en el NT. Fruto del Espíritu según Gálatas 5:22.",
    e: "De χρηστός (chrestos) = bueno, útil, benévolo"
  },
  "G5547": {
    m: "Cristo, Mesías, Ungido",
    d: "El Ungido, el Mesías; título de Jesús como Salvador prometido.",
    u: "Usado 529 veces en el NT. Jesús es el Cristo.",
    e: "De χρίω (chrio) = ungir"
  },
  "G5590": {
    m: "alma, vida",
    d: "El aliento de vida, el alma vital; la vida misma; el alma inmortal.",
    u: "Usado 105 veces en el NT. La vida espiritual y eterna.",
    e: "De ψύχω (psucho) = respirar, refrescar"
  },
  "H120": {
    m: "hombre, humanidad, Adán",
    d: "Hombre, ser humano; la humanidad; Adán el primer hombre.",
    u: "Usado 562 veces en el AT. Dios creó al hombre.",
    e: "De אָדֹם (adom) = rojo, o אֲדָמָה (adamah) = tierra"
  },
  "H160": {
    m: "amor, afecto",
    d: "Amor, afecto; acto de amor.",
    u: "Usado 40 veces en el AT. El amor de Dios por su pueblo.",
    e: "De אָהַב (ahab) = amar"
  },
  "H216": {
    m: "luz",
    d: "Luz natural o espiritual; felicidad, prosperidad.",
    u: "Usado 120 veces en el AT. '¡Sea la luz!'",
    e: "De אוֹר (or) = ser luminoso"
  },
  "H430": {
    m: "Dios, dioses",
    d: "El Dios supremo (Elohim); a veces usado para los jueces o los dioses paganos.",
    u: "Usado 2606 veces en el AT. Nombre plural de majestad para Dios.",
    e: "Plural de אֱלוֹהַּ (eloah) = dios"
  },
  "H559": {
    m: "decir, hablar",
    d: "Decir, hablar, declarar; mandar, pensar.",
    u: "Usado 5316 veces en el AT. El verbo de palabra más frecuente.",
    e: "Raíz primaria"
  },
  "H776": {
    m: "tierra, país",
    d: "Tierra, suelo; país, región; el mundo terrestre.",
    u: "Usado 2504 veces en el AT. La tierra que Dios creó.",
    e: "Raíz primaria"
  },
  "H982": {
    m: "confiar, tener confianza",
    d: "Confiar en, tener confianza; estar seguro.",
    u: "Usado 120 veces en el AT. Confianza en Yahvé.",
    e: "Raíz primaria"
  },
  "H1004": {
    m: "casa, morada",
    d: "Casa, habitación; familia, casa familiar; templo.",
    u: "Usado 2055 veces en el AT. La casa de Yahvé.",
    e: "De בָּנָה (banah) = construir"
  },
  "H1254": {
    m: "crear",
    d: "Crear de la nada; formar, hacer; actividad exclusiva de Dios.",
    u: "Usado 54 veces en el AT. Dios creó los cielos y la tierra.",
    e: "Raíz primaria"
  },
  "H1516": {
    m: "valle, barranco",
    d: "Valle, garganta, barranco; llanura.",
    u: "Usado 60 veces en el AT. El valle de sombra de muerte.",
    e: "Raíz primaria"
  },
  "H1878": {
    m: "engordar, hacer gordo",
    d: "Hacer gordo, engordar; prosperar.",
    u: "Usado 11 veces en el AT. Unges mi cabeza con aceite.",
    e: "De דֶּשֶׁן (deshen) = grasa, cenizas"
  },
  "H1980": {
    m: "andar, ir",
    d: "Andar, ir, venir; vivir, conducirse.",
    u: "Usado 1554 veces en el AT. Verbo de movimiento muy frecuente.",
    e: "Raíz primaria"
  },
  "H2617": {
    m: "bondad, misericordia, fidelidad",
    d: "Bondad, misericordia; fidelidad a la alianza; amor leal.",
    u: "Usado 248 veces en el AT. La bondad de Yahvé.",
    e: "De חָסַד (chasad) = ser bueno, misericordioso"
  },
  "H2637": {
    m: "faltar, necesitar",
    d: "Faltar, necesitar; disminuir, hacer falta.",
    u: "Usado 23 veces en el AT. Nada me faltará (Sal 23:1).",
    e: "Raíz primaria"
  },
  "H2896": {
    m: "bueno, bien",
    d: "Bueno, agradable, excelente; benévolo, justo.",
    u: "Usado 559 veces en el AT. Dios vio que era bueno.",
    e: "Raíz primaria"
  },
  "H3068": {
    m: "YHWH, Yahvé",
    d: "El nombre propio de Dios, tetragrama sagrado YHWH.",
    u: "Usado 6828 veces en el AT. El nombre más santo.",
    e: "De הָיָה (hayah) = ser, existir"
  },
  "H3117": {
    m: "día",
    d: "Día (opuesto a la noche); período de 24 horas; época, tiempo.",
    u: "Usado 2301 veces en el AT. El día que Yahvé hizo.",
    e: "De יוֹם (yowm) = estar caliente"
  },
  "H3372": {
    m: "temer, tener miedo, reverenciar",
    d: "Temer, tener miedo; reverenciar, respetar a Dios.",
    u: "Usado 335 veces en el AT. No temeré mal alguno.",
    e: "Raíz primaria"
  },
  "H3563": {
    m: "copa, cáliz",
    d: "Copa, cáliz; porción, suerte.",
    u: "Usado 31 veces en el AT. Mi copa está rebosando.",
    e: "Raíz primaria"
  },
  "H3820": {
    m: "corazón, mente",
    d: "Corazón, sede de las emociones; mente, inteligencia, voluntad.",
    u: "Usado 598 veces en el AT. El corazón del hombre.",
    e: "Raíz primaria"
  },
  "H3915": {
    m: "noche",
    d: "Noche (opuesta al día); tiempo de oscuridad.",
    u: "Usado 234 veces en el AT. Dios separó el día y la noche.",
    e: "Raíz primaria"
  },
  "H3966": {
    m: "muy, extremadamente",
    d: "Muy, extremadamente, mucho; con fuerza, rápidamente.",
    u: "Usado 300 veces en el AT. Era muy bueno.",
    e: "De מָאַד (ma'ad) = ser numeroso"
  },
  "H4325": {
    m: "agua, aguas",
    d: "Agua, aguas; lluvia; corriente, mar.",
    u: "Usado 585 veces en el AT. Las aguas de la creación.",
    e: "Dual de מַיִם (mayim) = agua"
  },
  "H4999": {
    m: "pasto, morada",
    d: "Lugar de pasto, pradera; habitación, morada.",
    u: "Usado 13 veces en el AT. En verdes pastos.",
    e: "De נָאָה (na'ah) = ser hermoso, conveniente"
  },
  "H5148": {
    m: "conducir, guiar",
    d: "Conducir, guiar, dirigir; llevar en seguridad.",
    u: "Usado 40 veces en el AT. Me guiará (Sal 23:3).",
    e: "Raíz primaria"
  },
  "H5216": {
    m: "pasto, tierra cultivada",
    d: "Pradera, pasto; tierra cultivada, campo.",
    u: "Usado 2 veces en el AT. Pastos verdeantes.",
    e: "De נִיר (niyr) = arar"
  },
  "H5315": {
    m: "alma, vida, persona",
    d: "Alma, vida, ser viviente; persona, sí mismo; deseo, apetito.",
    u: "Usado 753 veces en el AT. Mi alma, mi vida.",
    e: "De נָפַשׁ (naphash) = respirar"
  },
  "H5769": {
    m: "eternidad, siempre",
    d: "Tiempo indefinido, eternidad; siempre, perpetuidad.",
    u: "Usado 439 veces en el AT. El amor eterno de Dios.",
    e: "De עָלַם (alam) = ocultar, estar oculto"
  },
  "H6186": {
    m: "arreglar, disponer",
    d: "Arreglar en orden, disponer; preparar una mesa.",
    u: "Usado 75 veces en el AT. Preparas mesa (Sal 23:5).",
    e: "Raíz primaria"
  },
  "H6213": {
    m: "hacer, realizar",
    d: "Hacer, fabricar, realizar; actuar, trabajar.",
    u: "Usado 2632 veces en el AT. Verbo muy frecuente.",
    e: "Raíz primaria"
  },
  "H6664": {
    m: "justicia, rectitud",
    d: "Justicia, rectitud, equidad; fidelidad.",
    u: "Usado 119 veces en el AT. Sendas de justicia.",
    e: "De צָדַק (tsadaq) = ser justo"
  },
  "H6754": {
    m: "imagen, semejanza",
    d: "Imagen, semejanza; forma, apariencia.",
    u: "Usado 17 veces en el AT. El hombre creado a imagen de Dios.",
    e: "De צָלַל (tsalal) = sombrear, asemejarse"
  },
  "H6757": {
    m: "sombra de muerte, oscuridad profunda",
    d: "Tinieblas profundas, oscuridad mortal; sombra de muerte.",
    u: "Usado 18 veces en el AT. Simboliza el peligro extremo.",
    e: "De צֵל (tsel) = sombra + מָוֶת (maveth) = muerte"
  },
  "H6887": {
    m: "estar en angustia, adversario",
    d: "Estar apretado, en angustia; adversario, enemigo.",
    u: "Usado 58 veces en el AT. En presencia de mis adversarios.",
    e: "Raíz primaria"
  },
  "H7121": {
    m: "llamar, gritar, proclamar",
    d: "Llamar, gritar; nombrar; proclamar, convocar.",
    u: "Usado 736 veces en el AT. Invocar el nombre de Yahvé.",
    e: "Raíz primaria"
  },
  "H7200": {
    m: "ver, mirar",
    d: "Ver con los ojos; percibir, comprender; proveer.",
    u: "Usado 1311 veces en el AT. Dios vio que era bueno.",
    e: "Raíz primaria"
  },
  "H7225": {
    m: "principio, primicias",
    d: "Principio, comienzo; lo mejor, las primicias.",
    u: "Usado 51 veces en el AT. 'En el principio creó Dios...'",
    e: "De רֹאשׁ (rosh) = cabeza, principio"
  },
  "H7257": {
    m: "acostarse, reposar",
    d: "Acostarse, reposar; morar; empollar.",
    u: "Usado 30 veces en el AT. Me hace descansar (Sal 23:2).",
    e: "Raíz primaria"
  },
  "H7291": {
    m: "perseguir, cazar",
    d: "Perseguir, cazar; perseguir; seguir de cerca.",
    u: "Usado 144 veces en el AT. La bondad me seguirá.",
    e: "Raíz primaria"
  },
  "H7307": {
    m: "espíritu, aliento, viento",
    d: "Aliento, viento; espíritu de Dios o del hombre; disposición mental.",
    u: "Usado 378 veces en el AT. El Espíritu de Dios.",
    e: "De רוּחַ (ruach) = soplar"
  },
  "H7462": {
    m: "pastorear, apacentar, alimentar",
    d: "Apacentar un rebaño; ser pastor; alimentar, cuidar.",
    u: "Usado 173 veces en el AT. Yahvé es mi pastor.",
    e: "Raíz primaria"
  },
  "H7549": {
    m: "extensión, firmamento",
    d: "Extensión, bóveda celeste, firmamento; el cielo.",
    u: "Usado 17 veces en el AT. La expansión en medio de las aguas.",
    e: "De רָקַע (raqa) = extender, batir"
  },
  "H7626": {
    m: "vara, tribu",
    d: "Vara, cayado; tribu, rama familiar.",
    u: "Usado 190 veces en el AT. Tu vara y tu cayado.",
    e: "De שָׁבַט (shabat) = ramar"
  },
  "H7725": {
    m: "volver, regresar, restaurar",
    d: "Volver, regresar; restaurar, renovar; arrepentirse.",
    u: "Usado 1058 veces en el AT. Restaurar mi alma.",
    e: "Raíz primaria"
  },
  "H7979": {
    m: "mesa",
    d: "Mesa para comer; mesa de los panes de la proposición.",
    u: "Usado 71 veces en el AT. La mesa preparada.",
    e: "De שָׁלַח (shalach) = enviar, extender"
  },
  "H8064": {
    m: "cielos, cielo",
    d: "Cielos, firmamento; morada de Dios; cielo visible.",
    u: "Usado 420 veces en el AT. Los cielos y la tierra.",
    e: "Dual de שָׁמַיִם (shamayim) = alturas"
  },
  "H8414": {
    m: "informe, vacío, caos",
    d: "Desierto, desolación; caos, vacío, nada.",
    u: "Usado 20 veces en el AT. La tierra estaba desordenada y vacía.",
    e: "De תָּהָה (tahah) = errar"
  }
};

export default strongTranslationsES;
